const imageMap = {
    redPuzzle: "redPuzzle.jpeg",
    bluePuzzle: "bluePuzzle.jpeg",
    greenPuzzle: "greenPuzzle.jpeg",
    redBox: "redBox.jpeg",
    blueBox: "blueBox.jpeg",
    greenBox: "greenBox.jpeg",
    rightArrow: "rightArrow.jpeg",
    leftArrow: "leftArrow.jpeg",
    head: "head.jpeg",
    arms: "arms.jpeg",
    body: "body.jpeg",
    waist: "waist.jpeg",
    legs: "legs.jpeg",
    shield: "shield.jpeg",
    activation: "activation.jpeg",
    movement: "movement.jpeg",
    aiCard: "aiCard.jpeg",
    enDeavour: "endeavour.jpeg"
};

export default imageMap;